// extracted by mini-css-extract-plugin
export default {"socials":"SocialLinks_socials__b5sqc","socials--header":"SocialLinks_socials--header__G+Nsq"};